import faqImg from "../../assets/faq.svg";
import { useState } from "react";
import { faqData } from "../../constants/data";

export default function FAQ({ faqs }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-rows-1 md:flex-row flex-col items-center md:gap-x-0 lg:gap-x-14 gap-y-4">
        <div className="flex justify-center">
          <img src={faqImg} alt="fq" className="max-lg:w-[223px]" width={400} height={400} />
        </div>
        <div className="col-span-2">
          {faqData.map((faq, index) => (
            <div key={index} className="px-4 md:px-8 py-4">
              <button
                onClick={() => toggleFAQ(index)}
                className={`group flex justify-between items-center w-full text-left text-[14px] md:text-[16px] font-[600] ${
                  openIndex === index
                    ? 'text-[#510AC9]'
                    : 'text-[#220454] sm:text-[#1E1E1E] md:text-[#1E1E1E] lg:text-[#1E1E1E] xl:text-[#1E1E1E] hover:text-[#510AC9]'
                }`}
              >
                <span>{faq.question}</span>
                <span
                  className={`flex items-center justify-center w-3 h-2 transition-transform duration-200 fill-darkGray group-hover:fill-[#510AC9] min-w-4 min-h-4 ${openIndex === index ? "rotate-180" : ""}`}
                >
                  <svg
                    className={`w-3 h-2 transition-transform duration-200                       
                      group-hover:fill-primary fill-darkGray`}
                    viewBox="0 0 12 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.813195 0.646447C1.00846 0.451184 1.32504 0.451184 1.5203 0.646447L6.00008 5.12623L10.4799 0.646447C10.6751 0.451184 10.9917 0.451184 11.187 0.646447C11.3822 0.841709 11.3822 1.15829 11.187 1.35355L6.35363 6.18689C6.15837 6.38215 5.84179 6.38215 5.64653 6.18689L0.813195 1.35355C0.617933 1.15829 0.617933 0.841709 0.813195 0.646447Z"
                      fill="currentColor"
                    />
                  </svg>
                </span>
              </button>
              {openIndex === index && <p className="mt-3 text-sm font-medium text-[#374151]">{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
